import STORAGE_KEYS from '@/shared/constants/storage';
import { type AppUpdatePrompt } from './appUpdateDecision';

type DismissalStorage = Pick<Storage, 'getItem' | 'setItem'>;

const getDefaultStorage = (): DismissalStorage | null => {
	try {
		return window.sessionStorage;
	} catch {
		return null;
	}
};

const dismissalKey = ({ platform, threshold }: Pick<AppUpdatePrompt, 'platform' | 'threshold'>) =>
	`${STORAGE_KEYS.APP_UPDATE_DISMISSED}:${platform}:${threshold}`;

/** Remembered for the current app session only: a cold start opens a new web view and shows the prompt again. */
export const isAppUpdateDismissed = (
	prompt: Pick<AppUpdatePrompt, 'platform' | 'threshold'>,
	storage: DismissalStorage | null = getDefaultStorage(),
): boolean => {
	try {
		return storage?.getItem(dismissalKey(prompt)) === 'true';
	} catch {
		return false;
	}
};

export const recordAppUpdateDismissal = (
	prompt: Pick<AppUpdatePrompt, 'platform' | 'threshold'>,
	storage: DismissalStorage | null = getDefaultStorage(),
): void => {
	try {
		storage?.setItem(dismissalKey(prompt), 'true');
	} catch {
		// Storage unavailable: the prompt simply shows again.
	}
};
